import React from 'react';
import SizeMastersProvider from './size-masters-provider';

export default function withSizeMasters(WrappedComponent) {
  return function SizeMastersProviderHOC(props) {
    return (
      <SizeMastersProvider>
        <WrappedComponent {...props} />
      </SizeMastersProvider>
    );
  };
};
